import { useCurrentAgenteStore } from '@/stores/currentAgenteStore';

/**
 * Permissões do agente logado.
 *
 * Regra de negócio: agentes com status "AguardandoAprovacao" só podem
 * visualizar dados — não podem executar nenhuma ação que altere estado
 * (editar, aprovar, reprovar, arquivar, atribuir, criar, deletar, etc.).
 */
export function useAgentePermissions() {
  const { agente, status, isLoading, error } = useCurrentAgenteStore();

  const isAguardandoAprovacao = status === 'Aguardando Aprovação';

  // Read-only quando o agente está aguardando aprovação OU quando o agente
  // está arquivado. Caso contrário, permite ações normalmente.
  const isReadOnly = isAguardandoAprovacao || agente?.arquivado === true;
  
  // Verifica se o agente é gestor pelo campo gestor do agente atual
  const isGestor = agente?.gestor === true;

  return {
    agente,
    status,
    isAguardandoAprovacao,
    isReadOnly: Boolean(isReadOnly),
    isGestor: Boolean(isGestor),
    isLoading,
    error,
  };
}
